import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_skeleton = _resolveComponent("q-skeleton")!

  return (_openBlock(), _createElementBlock("div", {
    class: "chart-skeleton chart-skeleton__barchart",
    style: _normalizeStyle({ width: `${parseInt($setup.props.width)}${typeof $setup.props.width === 'string' && $setup.props.width.includes('%') ? '%' : 'px'}` })
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.sizes, (n, i) => {
      return (_openBlock(), _createBlock(_component_q_skeleton, {
        class: "chart-skeleton-item",
        type: "rect",
        width: `${parseInt($setup.props.itemWidth)}${typeof $setup.props.itemWidth === 'string' && $setup.props.itemWidth.includes('%') ? '%' : 'px'}`,
        height: `${n*$props.scale}px`
      }, null, 8, ["width", "height"]))
    }), 256))
  ], 4))
}